export default __webpack_public_path__ + "static/media/circleCloud14.562da764.png";